import { ClientInferResponseBody } from "@ts-rest/core";

import { contract } from "#app/http/api";
import { api } from "#app/http/api";

export type PredictionFeedbackDto = ClientInferResponseBody<
  typeof contract.feedback.getUserPredictionFeedback
>;

export const fetchPredictionFeedback = async (
  predictionId: string | undefined,
): Promise<PredictionFeedbackDto | null> => {
  if (!predictionId) {
    return null;
  }

  const response = await api.feedback.getUserPredictionFeedback.query({
    params: { predictionId },
  });

  if (response.status === 200) {
    return response.body;
  }

  return null;
};
